import axios from 'axios'
import { useContext, useState } from 'react'
import urlSearchParams from '../../components/urlSearchParams'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error } from '../../shared/constants'

export function useDownload() {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })

  const getPdfCsvData = async (url, dto = {}) => {
    console.log('in pdf csv data')
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    console.log('ji1', dto, url)
    axios
      .get(API[url](urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage('API Not Defined', error)
        }
      })
  }

  return {
    downloadLoading,
    getPdfCsvData,
    pdfCsvData,
  }
}
